import { useEffect, useRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Avatar,
    Box,
    ClickAwayListener,
    Grid,
    List,
    ListItemButton,
    ListItemText,
    Paper,
    Popper,
    Typography,
    useMediaQuery
} from '@mui/material';

// project imports
import Transitions from 'ui-component/extended/Transitions';

// assets
import useConfig from 'hooks/useConfig';

// ==============================|| LOCALIZATION ||============================== //

const LocalizationSection = () => {
    const { borderRadius, locale, onChangeLocale } = useConfig();

    const theme = useTheme();
    const matchesXs = useMediaQuery(theme.breakpoints.down('md'));

    const [open, setOpen] = useState(false);
    const anchorRef = useRef<any>(null);
    const [language, setLanguage] = useState<string>(locale);

    const handleListItemClick = (
        event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement, MouseEvent> | undefined,
        lng: string
    ) => {
        // onChangeFontFamily("'Poppins', 'Noto Sans KR', 'Noto Sans JP', sans-serif");
        // if (lng === 'ko') {
        //     onChangeFontFamily("'Poppins', 'Noto Sans KR', 'Noto Sans JP', sans-serif");
        // } else if (lng === 'ja') {
        //     onChangeFontFamily("'Poppins', 'Noto Sans KR', 'Noto Sans JP', sans-serif");
        // } else {
        //     onChangeFontFamily("'Poppins', sans-serif");
        // }

        setLanguage(lng);
        onChangeLocale(lng);

        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: MouseEvent | TouchEvent) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);

    useEffect(() => {
        var loc = locale;
        if (locale === '') {
            var tmp = (navigator.language || '').slice(0, 2);
            if (['en', 'ko', 'ja'].indexOf(tmp) === -1) {
                loc = 'en';
            } else {
                loc = tmp;
            }
        }
        setLanguage(loc);
    }, [locale]);

    return (
        <>
            <Box
                sx={{
                    ml: 2,
                    mr: 3,
                    [theme.breakpoints.down('md')]: {
                        mr: 2
                    }
                }}
            >
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        border: '1px solid',
                        borderColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.orange.light,
                        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.orange.light,
                        color: theme.palette.orange.dark,
                        transition: 'all .2s ease-in-out',
                        '&[aria-controls="menu-list-grow"],&:hover': {
                            borderColor: theme.palette.orange.main,
                            background: theme.palette.orange.main,
                            color: theme.palette.orange.light
                        }
                    }}
                    ref={anchorRef}
                    aria-controls={open ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    onClick={handleToggle}
                    color="inherit"
                >
                    <Typography variant="h5" sx={{ textTransform: 'uppercase' }} color="inherit">
                        {language}
                    </Typography>
                    {/*{language !== 'en' && (*/}
                    {/*    <Typography variant="h5" sx={{ textTransform: 'uppercase' }} color="inherit">*/}
                    {/*        {language}*/}
                    {/*    </Typography>*/}
                    {/*)}*/}
                    {/*{language === 'en' && <TranslateTwoToneIcon sx={{ fontSize: '1.3rem' }} />}*/}
                </Avatar>
            </Box>

            <Popper
                placement={matchesXs ? 'bottom-start' : 'bottom'}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                modifiers={[
                    {
                        name: 'offset',
                        options: {
                            offset: [matchesXs ? 0 : 0, 20]
                        }
                    }
                ]}
            >
                {({ TransitionProps }) => (
                    <ClickAwayListener onClickAway={handleClose}>
                        <Transitions position={matchesXs ? 'top-left' : 'top'} in={open} {...TransitionProps}>
                            <Paper elevation={16}>
                                {open && (
                                    <List
                                        component="nav"
                                        sx={{
                                            width: '100%',
                                            minWidth: 180,
                                            maxWidth: 280,
                                            bgcolor: theme.palette.background.paper,
                                            borderRadius: `${borderRadius}px`,
                                            [theme.breakpoints.down('md')]: {
                                                maxWidth: 250
                                            }
                                        }}
                                    >
                                        <ListItemButton selected={language === 'en'} onClick={(event) => handleListItemClick(event, 'en')}>
                                            <ListItemText
                                                primary={
                                                    <Grid container>
                                                        <Typography color="textPrimary">English</Typography>
                                                    </Grid>
                                                }
                                            />
                                        </ListItemButton>
                                        <ListItemButton selected={language === 'ko'} onClick={(event) => handleListItemClick(event, 'ko')}>
                                            <ListItemText
                                                primary={
                                                    <Grid container>
                                                        <Typography color="textPrimary">한국어</Typography>
                                                        <Typography variant="caption" color="textSecondary" sx={{ ml: '8px' }}>
                                                            (Korea)
                                                        </Typography>
                                                    </Grid>
                                                }
                                            />
                                        </ListItemButton>
                                        <ListItemButton selected={language === 'ja'} onClick={(event) => handleListItemClick(event, 'ja')}>
                                            <ListItemText
                                                primary={
                                                    <Grid container>
                                                        <Typography color="textPrimary">日本語</Typography>
                                                        <Typography variant="caption" color="textSecondary" sx={{ ml: '8px' }}>
                                                            (Japan)
                                                        </Typography>
                                                    </Grid>
                                                }
                                            />
                                        </ListItemButton>

                                        {/*<ListItemButton selected={language === 'fr'} onClick={(event) => handleListItemClick(event, 'fr')}>*/}
                                        {/*    <ListItemText*/}
                                        {/*        primary={*/}
                                        {/*            <Grid container>*/}
                                        {/*                <Typography color="textPrimary">français</Typography>*/}
                                        {/*                <Typography variant="caption" color="textSecondary" sx={{ ml: '8px' }}>*/}
                                        {/*                    (French)*/}
                                        {/*                </Typography>*/}
                                        {/*            </Grid>*/}
                                        {/*        }*/}
                                        {/*    />*/}
                                        {/*</ListItemButton>*/}
                                        {/*<ListItemButton selected={language === 'ro'} onClick={(event) => handleListItemClick(event, 'ro')}>*/}
                                        {/*    <ListItemText*/}
                                        {/*        primary={*/}
                                        {/*            <Grid container>*/}
                                        {/*                <Typography color="textPrimary">Română</Typography>*/}
                                        {/*                <Typography variant="caption" color="textSecondary" sx={{ ml: '8px' }}>*/}
                                        {/*                    (Romanian)*/}
                                        {/*                </Typography>*/}
                                        {/*            </Grid>*/}
                                        {/*        }*/}
                                        {/*    />*/}
                                        {/*</ListItemButton>*/}
                                        {/*<ListItemButton selected={language === 'zh'} onClick={(event) => handleListItemClick(event, 'zh')}>*/}
                                        {/*    <ListItemText*/}
                                        {/*        primary={*/}
                                        {/*            <Grid container>*/}
                                        {/*                <Typography color="textPrimary">中国人</Typography>*/}
                                        {/*                <Typography variant="caption" color="textSecondary" sx={{ ml: '8px' }}>*/}
                                        {/*                    (Chinese)*/}
                                        {/*                </Typography>*/}
                                        {/*            </Grid>*/}
                                        {/*        }*/}
                                        {/*    />*/}
                                        {/*</ListItemButton>*/}
                                    </List>
                                )}
                            </Paper>
                        </Transitions>
                    </ClickAwayListener>
                )}
            </Popper>
        </>
    );
};

export default LocalizationSection;
